import { render, staticRenderFns } from "./Productos.vue?vue&type=template&id=42e97f0b"
import script from "./Productos.vue?vue&type=script&lang=js"
export * from "./Productos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports